import CatalogueList from './List'
import CatalogueEdit from './Edit'
import CatalogueCreate from './Create'

const CatalogueResource = {
  list: CatalogueList,
  edit: CatalogueEdit,
  create: CatalogueCreate,
}

export default CatalogueResource
